import React from 'react'
import SpeakerPage from './SpeakerPage';

export default function Speaker() {

    return (
        <>
            <main id="tg-main" className="tg-main tg-haslayout">

                {/* Speaker */}
                <SpeakerPage color="rgb(238, 236, 234)" limit="0" />


            </main >
        </>
    )
}
